
import {
  Component,
  Inject,
  Model,
  Prop,
  Vue,
  Watch
} from "vue-property-decorator";
import Clickoutside from "@/views/ai-builder-component/plugins/clickoutside";
import { ElForm } from "element-ui/types/form";
import Color from "@/views/ai-builder-component/utils/colorHelper";
import PickerDropdownRange from "./picker-dropdown-range.vue";

@Component({
  directives: {
    Clickoutside
  },
  components: {
    PickerDropdownRange
  }
})
export default class HinaColorPicker extends Vue {
  @Inject({ default: "" }) readonly elForm!: ElForm;
  @Model("change") private readonly value!: { from: string; to: string };
  @Prop({ default: false }) private disabled!: boolean;
  @Prop({ default: false }) private showAlpha!: boolean;

  showPanelColor = false;
  showPicker = false;
  startColor: Color = new Color();
  endColor: Color = new Color();

  @Watch("value", { immediate: true, deep: true })
  changeValue({ from, to }: { from: string; to: string }) {
    if (from) {
      this.startColor.fromString(from);
    }
    if (to) {
      this.endColor.fromString(to);
    }
  }

  get colorDisabled() {
    return this.disabled || (this.elForm || {}).disabled;
  }

  get currentColor() {
    return {
      from: this.startColor.value,
      to: this.endColor.value
    };
  }

  hide() {
    this.showPicker = false;
    this.resetColor();
  }

  resetColor() {
    this.$nextTick(_ => {
      if (this.value.from && this.value.to) {
        const { from, to } = this.value;
        this.startColor?.fromString(from);
        this.endColor?.fromString(to);
      } else {
        this.showPanelColor = false;
      }
    });
  }

  handleTrigger() {
    if (this.colorDisabled) return;
    this.showPicker = !this.showPicker;
  }

  @Watch("currentColor")
  changeColor(val: string) {
    this.$emit("change", val);
  }
}
